// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EfN4","col":"styles_col__1Iq0b","actions":"styles_actions__263BT","conflict":"styles_conflict__2Vlq-"};